export default __webpack_public_path__ + "static/media/location.1dab0144.jpg";